import React from "react";
import { List, Typography, Avatar, Row, Col, Card, Tag, Button } from "antd";
import {
  ModuleColor,
  ModuleTagName,
} from "../../../../components/icons/ApplicationColor";
import "./NotificationsStyles.css";
import {
  EditOutlined,
  EllipsisOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useSelector } from "react-redux";
const { Text } = Typography;
const NotificationsDropdown = ({ data, count }) => {
  const userInfo = useSelector((state) => state.user);
  const history = useNavigate();
  const actions = [
    <Button
      style={{
        color: "#3457D5",
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: "13px",
        textAlign: "center",
      }}
    >
      Mark All As Read <EditOutlined key="edit" />
    </Button>,
    <Button
      style={{
        color: "#3457D5",
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: "13px",
        textAlign: "center",
      }}
      onClick={() => {
        userInfo?.data?.is_superadmin
          ? history(`/access-manager/notifications/view-notifications/`)
          : history(`/ca-admin/organization/communications/notifications/`);
      }}
    >
      View All Notifications <EllipsisOutlined key="ellipsis" />
    </Button>,
  ];

  return (
    <Card
      actions={actions}
      className="smallCard"
      title={
        <div
          style={{
            margin: "3px",
          }}
        >
          <span
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "black",
              fontFamily: "Poppins",
              fontWeight: 500,
              fontSize: "15.75px",
              textAlign: "center",
              width: "100%",
              letterSpacing: "1px",
            }}
          >
            UNREAD NOTIFICATIONS&nbsp;: &nbsp;
            <span style={{ color: "red", letterSpacing: "1px" }}>{count}</span>
          </span>
        </div>
      }
      //   bordered
      hoverable
    >
      <List
        itemLayout="vertical"
        dataSource={data}
        className="notifications-scroll"
        style={{
          borderRadius: "8px",
          overflowY: "auto",
          minHeight: "200px",
          maxHeight: "480px",
          width: "480px",
          display: "flex",
          flexDirection: "column",
        }}
        renderItem={(item) => (
          <Card
            hoverable
            onClick={() => {
              userInfo?.data?.is_superadmin
                ? history(
                    `/access-manager/notifications/view-notifications/${item.id}`
                  )
                : history(
                    `/ca-admin/organization/communications/notifications/${item.id}`
                  );
            }}
            style={{
              marginBottom: "5px",
              border: false ? "1px solid #1890ff" : "0.5px solid #E5E4E2",
              borderRadius: "8px",
              cursor: "pointer",
            }}
            size="small"
          >
            {/* Row for Sender, Receiver, and Notification Type */}
            <Row align="middle" gutter={16}>
              <Col>
                <Avatar
                  src={
                    item.sentBy.image ||
                    "https://cdn-icons-png.flaticon.com/512/1828/1828970.png"
                  }
                  alt={item.sentBy.name}
                  size="small"
                />
              </Col>
              <Col flex="auto">
                <Text
                  style={{
                    fontSize: "13.5px",
                    fontWeight: "500",
                    //   textDecoration: "underline",
                  }}
                  className="notifications"
                >
                  {item.type}
                </Text>
                <br />
              </Col>
              <Col style={{ display: "flex", alignItems: "center" }}>
                <Tag
                  color={ModuleColor(item.application)}
                  title={item.application}
                  style={{ marginRight: "8px" }}
                  size="small"
                >
                  <span
                    style={{
                      color: "black",
                      fontWeight: "500",
                    }}
                  >
                    {ModuleTagName(item.application)}
                  </span>
                </Tag>
                <Avatar
                  style={{
                    background:
                      Array.isArray(item?.receivedBy) &&
                      item.receivedBy.length > 1
                        ? "lightblue"
                        : "",
                  }}
                  src={
                    Array.isArray(item?.receivedBy) &&
                    item.receivedBy.length === 1 &&
                    item.receivedBy[0]?.image
                      ? item.receivedBy[0].image
                      : null
                  }
                  icon={
                    Array.isArray(item?.receivedBy) &&
                    item.receivedBy.length > 1 ? (
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: "500",
                          color: "black",
                        }}
                      >
                        {item.receivedBy.length}
                      </span>
                    ) : (
                      Array.isArray(item?.receivedBy) &&
                      item.receivedBy.length === 1 &&
                      !item.receivedBy[0]?.image && <UserOutlined />
                    )
                  }
                  alt={
                    Array.isArray(item?.receivedBy) &&
                    item.receivedBy.length === 1
                      ? item.receivedBy[0]?.name
                      : "participants"
                  }
                  size="small"
                />
              </Col>
            </Row>

            <div
              style={{
                marginTop: "5px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  fontSize: "11.5px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "70%",
                }}
                className="notifications"
              >
                {item.content}
              </Text>
              <Text
                style={{ color: "#8c8c8c", fontSize: "10px" }}
                className="notifications"
              >
                {moment(item.timestamp).format("MMM DD YYYY h:mm A")}
              </Text>
            </div>
          </Card>
        )}
      />
    </Card>
  );
};

export default NotificationsDropdown;
